<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        :class="fillClass + ' transition-fill'"
    >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
    </svg>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "PauseIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
        },
    },
});
</script>
